import { Category } from '@repo/types';
import { calculatePreviewChartContext } from '@repo/utils';
import { Card, Typography } from 'components';
import { categoryAnchorId } from 'views/Results/utils/categoriesAndMetrics';
import CategoryEmptyState from './CategoryEmptyState';
import MetricRow from './MetricRow';
import styles from './MetricsCategories.module.css';

type MetricsCategoriesProps = {
  categories: Category[];
  topPriorityRanks: Map<number, number>;
};

export default function MetricsCategories({
  categories,
  topPriorityRanks,
}: MetricsCategoriesProps) {
  return (
    <div className={styles.container}>
      {categories.map((category, idx) => {
        const hasAnyChart = category.orderedMetrics.some(metric =>
          metric.orderedSubmetrics.some(
            sm => calculatePreviewChartContext(sm).shouldRender,
          ),
        );

        return (
          <Card
            key={`${category.name}-${idx}`}
            id={categoryAnchorId(category)}
            className={styles.category}
            cardBodyClassName={styles.categoryCardBody}
          >
            <Typography variant='heading-l'>{category.name}</Typography>
            <Typography variant='subHeadline' color='grey' className='mt-1'>
              {category.short_description}
            </Typography>
            <div className={styles.metricRowsContainer}>
              {category.orderedMetrics.length === 0 ? (
                <CategoryEmptyState />
              ) : (
                category.orderedMetrics.map((metric, idx) => (
                  <MetricRow
                    key={`${metric.id}-${idx}`}
                    metric={metric}
                    idx={idx}
                    topPriorityRanks={topPriorityRanks}
                    hasAnyChart={hasAnyChart}
                  />
                ))
              )}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
